import * as React from "react";
import type { SectionDropLine } from "./sectionReorder";

export type { SectionDropLine } from "./sectionReorder";

export type SortableSectionsContextValue = {
  enabled: boolean;
  sectionIds: readonly string[];
  dragSrcId: string | null;
  /** True while the pointer is over the source slot (gallery-style square indicator). */
  dragSrcHover: boolean;
  dropLine: SectionDropLine | null;
  enteringIds: ReadonlySet<string>;
  onHandlePointerDown: (sectionId: string, title: string, e: React.PointerEvent) => void;
};

const defaultValue: SortableSectionsContextValue = {
  enabled: false,
  sectionIds: [],
  dragSrcId: null,
  dragSrcHover: false,
  dropLine: null,
  enteringIds: new Set(),
  onHandlePointerDown: () => {},
};

export const SortableSectionsContext =
  React.createContext<SortableSectionsContextValue>(defaultValue);

export function useSortableSections(): SortableSectionsContextValue {
  return React.useContext(SortableSectionsContext);
}
